export default __webpack_public_path__ + "scene4_2_bg2f1745.png";